<template>
  <div class="variable-display">
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col cols="11">
            <QuestionId :id="variable.question.id"></QuestionId>
            {{ variable.question.prompt }}
            <br />
            <VariableId :id="variable.id"></VariableId>
            <strong>{{ variable.input_label }}</strong>
            <slot name="extra-option" />
          </b-col>
          <slot name="remove-icon" />
        </b-row>
      </b-card-header>
    </b-card>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import QuestionId from '@/components/QuestionId.vue';
import VariableId from '@/components/VariableId.vue';

export default {
  name: 'variableDisplay',
  components: {
    QuestionId,
    VariableId,
  },
  props: {
    variable: Object,
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.variable-display {
  display: block;
}
</style>
